import { render, staticRenderFns } from "./baseUpload.vue?vue&type=template&id=2a903194&scoped=true"
import script from "./baseUpload.vue?vue&type=script&lang=js"
export * from "./baseUpload.vue?vue&type=script&lang=js"
import style0 from "./baseUpload.vue?vue&type=style&index=0&id=2a903194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a903194",
  null
  
)

export default component.exports